import PropTypes from 'prop-types';

const TEAM_PROP_TYPES = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
});

export default TEAM_PROP_TYPES;
